var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2757 3.33335H14.005C14.3704 3.33335 14.6664 3.63001 14.6664 4.00001V13.3333C14.6664 13.7013 14.363 14 14.005 14H1.99435C1.90711 13.9998 1.82075 13.9824 1.74024 13.9488C1.65974 13.9152 1.58667 13.866 1.52522 13.804C1.46377 13.7421 1.41517 13.6686 1.38218 13.5879C1.3492 13.5071 1.33249 13.4206 1.33302 13.3333V4.00001C1.33302 3.63201 1.63635 3.33335 1.99435 3.33335H5.72369L4.03302 1.64268L4.97569 0.700012L7.60902 3.33335H8.39035L11.0237 0.700012L11.9664 1.64268L10.2757 3.33335ZM2.66635 4.66668V12.6667H13.333V4.66668H2.66635Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.bf38e231.svg";
export { ForwardRef as ReactComponent };